export default {
    ACTIVITY_SET_SELECTED: 'ACTIVITY_SET_SELECTED'
}